import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter,
	createReducer,
} from '@reduxjs/toolkit';

import  MessageExploder from "../../reducers/MessageExploder";
import { NAME, LIMIT } from './constants';



const liveReducer = (state, action) => {
	// parse the message itself
	let data = action.data;
	try {
		if(typeof data.payload.message === 'string')
			data.payload.message = JSON.parse(data.payload.message);
		console.log("live reducer: %o", data);
		state.notifications.unshift(...MessageExploder(data));
		state.notifications = state.notifications.slice(0, LIMIT);
	}
	catch(ex) {
		console.error(ex);
		console.error("data: %o", data);
	}
}

const defaultReducer = (state, action) => {
	let data = action.data;
	state.notifications.unshift(...MessageExploder(data));
	state.notifications = state.notifications.slice(0, LIMIT);		
};

const removeNotificationReducer = (state, action) => {
	let data = action.data;
	console.log(data);
	let keys = MessageExploder(data).map(m => { if(m.request) { return m.request.key; } else { return null; } });
	    console.log("KEYS: %o", keys);
	state.notifications = state.notifications.filter((m) => m.request && keys.indexOf(m.request.key) === -1);

//	console.log(JSON.stringify(state, undefined, 2));
	// // 	    /* filter out this request */
	// // 	    return state.filter( (element) => (!element.request || (keys.indexOf(element.request.key) === -1) ));
	//
	// state.notifications.unshift(...MessageExploder(data));
	// let keysToRemove = action.data.meta.requests.map((r) => r.key);

//	state.unclaimed.keys = state.unclaimed.keys.filter((k) => keysToRemove.indexOf(k) === -1);

};

const notificationsSlice = createSlice({
	name: NAME,
	initialState: { notifications: [], loading: 'idle' },
	reducers: {

	},
	extraReducers: {
		"NOTIFICATION_REQUEST_LIVE": liveReducer,
		"NOTIFICATION_LIVE_ADD":  liveReducer,
		
		"NOTIFICATION_ADD": defaultReducer,

		"NOTIFICATION_REQUEST_AVAILABLE": defaultReducer,
		"NOTIFICATION_MENTOR_REQUEST_AVAILABLE": defaultReducer,
		"NOTIFICATION_FORUM_COMMENT": defaultReducer,
		"NOTIFICATION_FORUM_POST": defaultReducer,


		"NOTIFICATION_REQUEST_UNAVAILABLE": removeNotificationReducer,


		// "NOTIFICATION_QUIZ_UPDATED": (state, action) => {
		// 	let data = action.data;
		// 	state.notifications = Object.assign([], state, [
		// 		state.notifications.unshift(...MessageExploder(data))
		// 		state.notifications = state.notifications.slice(0, LIMIT);			
		// },
		// "NOTIFICATION_QUIZ_ACTIVATED": (state, action) => {
		// 	let data = action.data;
		// 	state.notifications.unshift(...MessageExploder(data))
		// 	state.notifications = state.notifications.slice(0, LIMIT);		
		// },
		// "NOTIFICATION_QUIZ_PASSED": (state, action) => {
		// 	let data = action.data;
		// 	state.notifications.unshift(...MessageExploder(data))
		// 	state.notifications = state.notifications.slice(0, LIMIT);			
		// },
		// "NOTIFICATION_QUIZ_FAILED": (state, action) => {
		// 	let data = action.data;
		// 	state.notifications.unshift(...MessageExploder(data))
		// 	state.notifications = state.notifications.slice(0, LIMIT);		
		// }
	}
});


export default notificationsSlice.reducer; 




// // import FancyActionTypes from '../data/FancyActionTypes';




// // const NotificationMessages = (state = [], action) => {
    
    
// //     let data = action.data;
// //     let LIMIT = 5;

    
// //     switch (action.type) {

// //     		"NOTIFICATION_CLEAR": (state, action) => {
	
// }
// // 	return [];
	
// //     		"NOTIFICATION_ADD": (state, action) => {
	
// }
// //     		"NOTIFICATION_REQUEST_AVAILABLE": (state, action) => {
	
// }
// //     		"NOTIFICATION_MENTOR_REQUEST_AVAILABLE": (state, action) => {
	
// }
// //     		"NOTIFICATION_FORUM_COMMENT": (state, action) => {
	
// }
// //     		"NOTIFICATION_FORUM_POST": (state, action) => {
	
// }
// //     		"NOTIFICATION_QUIZ_UPDATED": (state, action) => {
	
// }
// //     		"NOTIFICATION_QUIZ_ACTIVATED": (state, action) => {
	
// }
// //     		"NOTIFICATION_QUIZ_PASSED": (state, action) => {
	
// }
// //     		"NOTIFICATION_QUIZ_FAILED": (state, action) => {
	
// }
// //     		"CHAT_ADD:"	 (state, action) => {
	
// }
// // 	return Object.assign([], state, [
// // 	    ...MessageExploder(data),
// // 	    ...state.slice(0, LIMIT)
// // 	]);


// //     		"NOTIFICATION_LIVE_ADD": (state, action) => {
	
// }
// //     		"NOTIFICATION_REQUEST_LIVE": (state, action) => {
	
// }

// // 	// parse the message itself
// // 	try {
// // 	    if(typeof data.payload.message === 'string')
// // 		data.payload.message = JSON.parse(data.payload.message);
	    
// // 	    return Object.assign([], state, [
// // 		...MessageExploder(data),
// // 		...state.slice(0, LIMIT)
// // 	    ]);
// // 	}
// // 	catch(ex) {
// // 	    console.error(ex);
// // 	    console.error("data: %o", data);
// // 	}



// //     // 		"CHAT_ADD": (state, action) => {
	
// }
// //     // 	// parse the message itself
// //     // 	try {
// //     // 	    console.log(data.payload);
// //     // 	    return state;
// //     // 	    // if(typeof data.payload.message === 'string')
// //     // 	    // 	data.payload.message = JSON.parse(data.payload.message);
	    
// //     // 	    // return Object.assign([], state, [
// //     // 	    // 	...MessageExploder(data),
// //     // 	    // 	...state.slice(0, LIMIT)
// //     // 	    // ]);
// //     // 	}
// //     // 	catch(ex) {
// //     // 	    console.error(ex);
// //     // 	    console.error("data: %o", data);
// //     // 	}
	

// //     		"NOTIFICATION_REQUEST_UNAVAILABLE": (state, action) => {
	
// }
// //     		"NOTIFICATION_MENTOR_REQUEST_UNAVAILABLE": (state, action) => {
	
// }
// // 	try {
// // 	    /* get the request keys from the notifications _request_unavailable */
// // 	    let keys = MessageExploder(data).map(m => { if(m.request) { return m.request.key; } else { return null; } });
	    
// // 	    /* filter out this request */
// // 	    return state.filter( (element) => (!element.request || (keys.indexOf(element.request.key) === -1) ));
// // 	} catch (ex) {
// // 	    console.log("error handling request-unavailable: %o", ex);
// // 	    return state;
// // 	}
	
// //     default:
// // 	return state;
// //     }
// // }

